// Team Slider
if (document.querySelector('.team-slider')) {
    const teamSwiper = new Swiper('.team-slider .swiper', {
        // Optional parameters
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        autoplay: {
            delay: 5000,
        },

        // Navigation arrows
        navigation: {
            nextEl: '.team-button-next',
            prevEl: '.team-button-prev',
        },

        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        },
    });
}
